import './PopupEditButton.less';
import React, {useState, useEffect} from 'react';
import Icon from "../../../bootstrap/components/icon/Icon";
import __ from "../../i18n";
import Popup from "../../../bootstrap/components/popup/Popup";


export default function PopupEditButton(
    {
        icon = 'cog',
        label = __('Edit'),
        popupTitle = __('Edit'),
        getEditor = (close) => null
    }
) {

    const [popupShown, setPopupShown] = useState(false);

    const open = () => setPopupShown(true);

    const close = () => setPopupShown(false);

    return <>
        <a
            className="popup-edit-button"
            onClick={open}
        >
            <Icon name={icon}/>
            <span className="text">{label}</span>
        </a>
        {
            popupShown &&
            <Popup
                title={popupTitle}
                close={close}
            >
                {getEditor(close)}
            </Popup>
        }
    </>;
}
